import { css, type Theme } from "@emotion/react";

import { hoverBoxShadow } from "@styles/emotion-styles/animations";
import * as dimensions from "@styles/emotion-styles/dimensions";
import { borderRadius } from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";

export const container = (theme: Theme) => css`
  position: absolute;
  width: 100%;
  top: 100%;
  ${hoverBoxShadow};
  background-color: ${theme.surface.level1};
  display: flex;
  flex-direction: column;
  padding: 0;
  z-index: ${layers.indexOverlay};
  border-radius: ${borderRadius};
  @media (max-width: ${dimensions.phoneLargeMax}) {
    max-height: 90vh;
    overflow-y: auto;
  }
`;
